/** @jsxImportSource @emotion/react */

import { notification } from "antd";
import { ReactComponent as TransferIcon } from "assets/Common/icons/icon-transfer.svg";
import HelmetCustom from "components/Common/HelmetCustom";
import HeaderCustom from "components/Mobile/ui/HeaderCustom";
import { canAccessTransfer } from "helpers/permissionAccess";
import { useAppSelector } from "hooks/app-hook";
import { useCallback, useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { selectUsername } from "store/auth";
import { StatusNotification } from "types";

import { TransferPageStyle } from "./style";
import { TransferPointCard } from "./TransferPointCard";
import TransferPointHistory from "./TransferPointHistory";
import { TransferWalletCard } from "./TransferWalletCard";

const TransferPage = () => {
  const { t } = useTranslation(["transferPage"]);
  const username = useAppSelector(selectUsername);
  const navigator = useNavigate();
  const [transferHistoryRefreshKey, setTransferHistoryRefreshKey] =
    useState<number>(0);

  const [api, contextHolder] = notification.useNotification();

  const openNotification = useCallback(
    (status: StatusNotification, message: string) => {
      api[status]({
        message,
        description: "",
      });
    },
    [api]
  );

  // LIMIT ACCOUNT
  useEffect(() => {
    if (!canAccessTransfer(username)) {
      return navigator("/");
    }
  }, [navigator, username]);

  // ACCESS TO UPLINE ACCOUNT
  const UPLINE_PERMISSION = ["testreferral", "eddtest"].includes(username);

  return (
    <>
      <HelmetCustom title={t("TransferPage")} />
      {isMobile && <HeaderCustom title={t("TransferPage")} />}
      <div css={TransferPageStyle.wrapper}>
        {!isMobile && (
          <div css={TransferPageStyle.header}>
            <TransferIcon width={24} height={24} />
            <span>{t("TransferOptions")}</span>
          </div>
        )}
        {/* Transfer cash to coin */}
        <TransferWalletCard
          username={username}
          openNotification={openNotification}
        />
        {/* Transfer Cash to Upline */}
        {UPLINE_PERMISSION && (
          <>
            <TransferPointCard
              username={username}
              openNotification={openNotification}
              onTransferSuccess={() =>
                setTransferHistoryRefreshKey((prev) => prev + 1)
              }
            />
            {/* Transfer History */}
            <TransferPointHistory
              username={username}
              refreshKey={transferHistoryRefreshKey}
            />
          </>
        )}
        {contextHolder}
      </div>
    </>
  );
};
export default TransferPage;
